import { Collapse, Link, List, Typography } from '@mui/material';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import useLocales from '#/hooks/useLocales';
import { Item } from '#/components/shared/ui/navbar/navConfig';
import { getActive } from '#/components/shared/ui/navbar/NavItem';
import Iconify from '#/components/shared/ui/Iconify';

type MobileMegaMenuItemProps = {
  mobileCollapse: boolean;
  items: Item[];
  onCloseNav?: VoidFunction;
};

export default function MobileMegaMenuItem({
  mobileCollapse,
  items,
  onCloseNav,
}: MobileMegaMenuItemProps) {
  return (
    <Collapse in={mobileCollapse} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        {items.map((item) => (
          <CollapseItem onCloseNav={onCloseNav} item={item} key={item.title} />
        ))}
      </List>
    </Collapse>
  );
}

const CollapseItem = ({
  item,
  onCloseNav,
}: {
  item: Item;
  onCloseNav?: VoidFunction;
}) => {
  const { translate } = useLocales();

  const { url, title } = item;

  const { pathname } = useLocation();

  const active = getActive(url, pathname);

  return (
    <Link
      component={RouterLink}
      key={item.title}
      to={item.url}
      sx={{
        display: 'flex',
        alignItems: 'center',
        pl: 3,
        py: 0.5,
        color: 'text.primary',
        textDecoration: 'none !important',
        opacity: 0.5,
        ...(active && {
          pl: 1,
          opacity: 1,
          color: 'primary.main',
        }),
      }}
      onClick={onCloseNav}
    >
      {active && <Iconify icon="oui:dot" />}
      <Typography noWrap>{String(translate(title))}</Typography>
    </Link>
  );
};
